import { HierarchicalFields } from '../api/api-interfaces';
import { DataTypes } from '../constants/constants';
import { ExecutorRoleViewAuthorizationService } from '../v2/api/authorization/service';
import { AllUsedFields, DataFields, DataFieldWithDataType } from '../v2/types';
import { nonUserVisibleFields } from '../v2/utils';

export const GetNonNullFieldsForDataTypeService = (
  dataType: DataTypes,
  allUsedFields: AllUsedFields
): DataFieldWithDataType[] => {
  const usedFieldsForDataType:
    | { dataType: DataTypes; datafields: DataFields[] }
    | undefined = allUsedFields.find((f) => f.dataType === dataType);

  const converted = usedFieldsForDataType?.datafields.map((df) => ({
    dataType,
    dataField: df,
  }));

  if (!converted) {
    console.error(`Could not get non-null fields for dataType ${dataType}`);
    throw new Error(`Could not get non-null fields for dataType ${dataType}`);
  } else {
    return converted;
  }
};

export const GetUserVisibleNonConfidentialNonNullFieldsForDataTypeService = (
  dataType: DataTypes,
  authorizationService: ExecutorRoleViewAuthorizationService,
  allUsedFields: AllUsedFields
): DataFieldWithDataType[] => {
  const usedFields = GetNonNullFieldsForDataTypeService(
    dataType,
    allUsedFields
  );
  const toKey = (f: DataFieldWithDataType) => `${f.dataType}:${f.dataField}`;
  const excludedKeys = new Set(
    [...nonUserVisibleFields, ...HierarchicalFields].map(toKey)
  );
  const filteredUsedFields = usedFields.filter(
    (f) => !excludedKeys.has(toKey(f))
  );
  return filteredUsedFields.filter((f) => authorizationService.canSeeField(f));
};
